module.exports = __webpack_public_path__ + "img/Severna Makedonija.151bb853.png";